import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyA0-IcfpdyOvSwpqdwwUge_h7JrMgSAG0g",
  authDomain: "alwaleed-56c8b.firebaseapp.com",
  projectId: "alwaleed-56c8b",
  storageBucket: "alwaleed-56c8b.appspot.com", // ⚠️ corrige ici: remplace `.firebasestorage.app` par `.appspot.com`
  messagingSenderId: "943760388727",
  appId: "1:943760388727:web:c450851d49e2422ee5cc72",
  measurementId: "G-T9HY93N2QJ"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const provider = new GoogleAuthProvider();

export { auth, db, storage, provider };
